import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import * as olProj from 'ol/proj';
import LineString from 'ol/geom/LineString';
import {  Select } from 'ol/interaction';
import { of, Observable, Subscription, interval, takeWhile } from 'rxjs';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { AirSpaceBoundaryModel } from '../models/air-space-boundary';
import { FeatureType } from '../models/EnumTypes';
import { ErrorModel } from '../models/error';
import { NavaidModel } from '../models/navaid';
import { SearchItem } from '../models/searchItem';
import { DynamicTable } from '../popup/dynamic-table/dynamic-table.component';
import { SelectCoordinatePointsControlService } from '../popup/services/select-coordinate-points-control.service';
import { EndpointsService } from './endpoints.service';
import { MapService } from './map.service';
import { ModalConfirmationService } from './modal-confirmation.service';
import { ModalControlService } from './modal-control.service';
import { NavaidsService } from './navaids.service';
import { PointsService } from './points.service';
import { ProjectService } from './project.service';
import { SearchService } from './search.service';
import { ToolsControlService } from './tools-control.service';
import { UtilsService } from './utils.service';
import { ParentLayers } from '../menu/view-menu/parent-layer';
import { AirSpaceBoundaryCoordinatePointModel } from '../models/air-space-boundary-coordinate-point';
import { AirSpaceBoundaryVertexLineModel } from '../models/AirSpaceBoundaryVertexLine';
import { EventsKey } from 'ol/events';
import { CoordinatePointModel } from '../models/coordinate-point';
import olMap from 'ol/Map';
import { SelectCoordinatePointComponent } from '../popup/select-coordinate-point/select-coordinate-point.component';
import { unByKey } from 'ol/Observable';
import { VectorLayerDMTR } from '../menu/view-menu/layer';
import { cloneDeep } from 'lodash';
import { CoordenateService } from './coordenate.service';
import { CoordinatePointsService } from './coordinate-points.service';
import Geometry from 'ol/geom/Geometry';
import { ConfigurationService } from './configuration.service';
import { UiBlockService } from './ui-block.service';
import { MultiPoint } from 'ol/geom';

@Injectable({
  providedIn: 'root'
})
export class AirspaceBoundariesControlService {

  public active: boolean;
  public fullScreenMode:boolean = false;
  public previousSelectedNavaid : NavaidModel = null;
  public previousSelectedNavaidFeature: Feature<Geometry>;

  airspaceBoundaires: AirSpaceBoundaryModel[] = [];
  eventKey: EventsKey;
  map: olMap;
  edit:boolean;
  currentCreateID : number = 0;
  constructor(private projectService : ProjectService,
     private searchService : SearchService,
     private mapService : MapService,
     private http: HttpClient,
     private globalSelectionService : GlobalSelectionControlService,
     public selectCoordinatePointService : SelectCoordinatePointsControlService,
     private endpointService : EndpointsService,
     private modalService : ModalControlService,
     public pointsService : PointsService,
     private modalConfirmation : ModalConfirmationService,
     private toolsService : ToolsControlService,
     private utilsService : UtilsService,
     private popupService : BsModalService,
     private navaidController : NavaidsService,
     private rcsControl: CoordenateService,
     public coordinatePointsService: CoordinatePointsService,
     private configurationService: ConfigurationService,
     private uiBlock: UiBlockService,
 ) {
    this.map = this.mapService.getMap('map');
    // const checkAuthSubscription: Subscription = interval(100) // ms
    //   .pipe(takeWhile(() => !this.endpointService.httpOptions, true))
    //   .subscribe(() => {
    //     if (this.endpointService.httpOptions) {
    //       checkAuthSubscription.unsubscribe();
    //       this.initCurrentCreateId();
    //     }
    //   });

  }

  initCurrentCreateId() {
    this.pointsService.getAirSpaceBoundaries().subscribe((airspaceBoundaries) => {
      airspaceBoundaries.forEach((boundary) => {
        if (boundary.id > this.currentCreateID)
          this.currentCreateID = boundary.id;
      }
      )
    });
  }

   openFooter(){
    if(this.active){
      return;
    }
    this.active = true;
    this.selectCoordinatePointService.airSpaceBoundaryActive = this.active;
    this.createDblClickEvent();
    const vertexLayer = this.globalSelectionService.coordinatePointsLayers.childLayers[0].layers
      .find((element) => element.id === 'airspace_vertex');

    vertexLayer.visible = true;
    vertexLayer.olLayer.setVisible(true)
   }

   createDblClickEvent(){
    let thisComponent = this;
    let thisSelectCoordinatePointControl = this.selectCoordinatePointService;
    let thisPointsService = this.pointsService;
    let thisModalService = this.modalService;
    let thisRcsControl = this.rcsControl;
    let nearCoordPoints : CoordinatePointModel[] = [];
    let hitTolerance = 5;

    this.eventKey = this.map.on('dblclick', function(event){
      if(!this.globalSelectionService.skipClick){
        nearCoordPoints = [];
        let hit =   false;
        var coords = olProj.toLonLat(event.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
        let clickedCoordinates : CoordinatePointModel = new CoordinatePointModel();
        clickedCoordinates.latitude = Math.round(coords[1] * 100000) / 100000;
        clickedCoordinates.longitude = Math.round(coords[0] * 100000) / 100000;
        nearCoordPoints.push(clickedCoordinates);


        thisComponent.map.forEachFeatureAtPixel(
          event.pixel,
          function (feat : Feature) {
            if (feat.getGeometry() instanceof MultiPoint && feat.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY) == "airspace_vertex") {
              const geometry: MultiPoint = feat.getGeometry() as MultiPoint;
              const nearestPoint = geometry.getClosestPoint(event.coordinate);

              if (nearestPoint) {
                const pointPixel = thisComponent.map.getPixelFromCoordinate(nearestPoint);
                const pixelDistance = Math.sqrt(
                  Math.pow(pointPixel[0] - event.pixel[0], 2) +
                  Math.pow(pointPixel[1] - event.pixel[1], 2)
                );
                if (pixelDistance <= hitTolerance) {
                  const pointFeature = thisComponent.pointsService.getCoordinatePointFeatureFromLayersByCoordinate
                  (
                    nearestPoint,
                    feat.get(CoordinatePointModel.LAYER_ID_FEATURE_PROPERTY),
                    feat.get(CoordinatePointModel.PUBLISHED_FEATURE_PROPERTY)
                  );
                  hit = true;
                  nearCoordPoints.push(thisPointsService.transformFeatureInCoordinatePoint(pointFeature));
                }
              }
            }
          },
          {
            hitTolerance: hitTolerance,
          }
        );
        if(thisComponent.active){

          var coords = olProj.toLonLat(event.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
          var lat = Math.round(coords[1] * 100000) / 100000;
          var long = Math.round(coords[0] * 100000) / 100000;

          if (hit) {
            thisSelectCoordinatePointControl.isFromAirSpaceBoundary = true;
            thisSelectCoordinatePointControl.coordinatePointsModal = nearCoordPoints;
            const bsModalRef: BsModalRef = thisComponent.popupService.show(SelectCoordinatePointComponent);
            bsModalRef.content.airspaceService = thisComponent;
            thisSelectCoordinatePointControl.isFromAirSpaceBoundary = false;
          } else
          {
              let emptyProcedureCoordinatePoint : AirSpaceBoundaryCoordinatePointModel = new AirSpaceBoundaryCoordinatePointModel();
              let emptyCoordPoint: CoordinatePointModel = new CoordinatePointModel();
              emptyCoordPoint.coordpointid = "";
              emptyCoordPoint.name = "";
              emptyCoordPoint.empty = false;
              emptyCoordPoint.type = "AIRSPACE_BOUNDARY_VERTEX";
              emptyCoordPoint.nominalaltitude = 0;
              emptyCoordPoint.published = false;
              emptyCoordPoint.longitude = long;
              emptyCoordPoint.latitude = lat;
              emptyProcedureCoordinatePoint.coordPoint = emptyCoordPoint;

              thisSelectCoordinatePointControl.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.push(emptyProcedureCoordinatePoint);

              thisComponent.drawLegs();
            }
        }
      }

    }.bind(this));
   }
   deleteProcedureLegsOnMap(){
    let source = this.selectCoordinatePointService.getLayerSourceFromAirSpaceBoundaryType(this.selectCoordinatePointService.selectedAirSpaceBoundary);
    const boundary = this.selectCoordinatePointService.selectedAirSpaceBoundary;
    const features = source.getFeatures();
    features.forEach(feat => {
      const featId = feat.get('id');
      const featUniqueId = feat.get('uniqueid');
      const boundaryId = boundary.id != null ? boundary.id.toString() : null;
      const boundaryUniqueId = boundary.uniqueid;
      const tempId = 'TEMP_CREATE_AIRSPACE_BOUNDARY_' + this.currentCreateID;
      const tempBoundaryId = boundary.id != null ? 'TEMP_AIRSPACE_BOUNDARY_' + boundary.id : null;
      if (
        (boundaryId && featId === boundaryId) ||
        (boundaryUniqueId && featUniqueId === boundaryUniqueId) ||
        (tempBoundaryId && featId === tempBoundaryId) ||
        (featId === tempId)
      ) {
        source.removeFeature(feat);
      }
    });
  }
   drawLegs(): void {
    this.deleteProcedureLegsOnMap();
    let lineId = 0;
    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines = [];

    const points = this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints;
    if (points.length > 2) {
      for (let i = 0; i < points.length; i++) {
        const startPoint = points[i];
        const endPoint = points[(i + 1) % points.length]; // wrap to first point
        const leg = new AirSpaceBoundaryVertexLineModel();
        leg.isstraightleg = true;
        leg.startPoint = startPoint;
        leg.endPoint = endPoint;
        leg.id = `l${lineId++}`;
        if (this.selectCoordinatePointService.selectedAirSpaceBoundary.id != null)
          this.selectCoordinatePointService.addLineToMap(leg, this.selectCoordinatePointService.selectedAirSpaceBoundary);
        else
          this.selectCoordinatePointService.addLineToMap(leg, this.selectCoordinatePointService.selectedAirSpaceBoundary, this.currentCreateID);
        this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines.push(leg);
      }
    }

    this.reSequence();

  }
  reSequence(): void {
    let legSeq: number = 1;
    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryLines.forEach( leg => {
      if (leg.startPoint != null) {
        leg.startPoint.sequencenumber = legSeq;
        legSeq++;
      }
      if (leg.endPoint != null) {
        leg.endPoint.sequencenumber = legSeq;
        legSeq++;
      }
    });

    legSeq = 1;
    this.selectCoordinatePointService.selectedAirSpaceBoundary.airSpaceBoundaryCoordinatePoints.forEach( leg => {
      leg.sequencenumber = legSeq;
      legSeq++;
    });

  }
  hideFooter(){
    this.active = false;
    this.selectCoordinatePointService.airSpaceBoundaryActive = this.active; // include in switch function
    unByKey(this.eventKey); // include in switch function
  }
  //cancel
   closeFooter(save:boolean=false, isClose : boolean){
    this.hideFooter();
    if(save){
      return;
    }
    this.restoreMap(true, !save);


   }

   restoreMap(cleanTemporary : boolean = true, isClose : boolean = false,temp_id?:number,airspaceBoundary?: AirSpaceBoundaryModel) {
    /*if(this.selectCoordinatePointService.selectedAirSpaceBoundary.id == undefined){
      return;
    }*/
    if(typeof temp_id == 'undefined'){
      temp_id = this.currentCreateID
    }
    if(typeof airspaceBoundary == 'undefined'){
      airspaceBoundary = this.selectCoordinatePointService.selectedAirSpaceBoundary;
    }
    let layer : VectorLayerDMTR = this.pointsService.airspaceboundariesLayers.childLayers[0].layers
    .find((element) => element.id === 'Air_Space_Boundary')
    .olLayer

    var vectorSource = layer.getSource();
    this.pointsService.getAllAirSpaceBoundaryFeaturesFromLayers().forEach( feature => {
      if(airspaceBoundary.id != undefined ){
        if( feature.get('id') == airspaceBoundary.id.toString()){
          vectorSource.removeFeature(feature);
        }
        if(feature.get('id') == 'TEMP_AIRSPACE_BOUNDARY_' + airspaceBoundary.id && cleanTemporary){
          vectorSource.removeFeature(feature);
        }
      }
      else {
        if((feature.get('id') == 'TEMP_CREATE_AIRSPACE_BOUNDARY_' + temp_id || feature.get('id') == "TEMP_CREATE_AIRSPACE_BOUNDARY_undefined" )&& cleanTemporary){
          vectorSource.removeFeature(feature);
        }
      }
    });

    if(isClose){
      if(this.selectCoordinatePointService.selectedAirSpaceBoundary.id != null) {
        this.pointsService.getAirSpaceBoundaryByID(this.selectCoordinatePointService.selectedAirSpaceBoundary.id.toString()).subscribe( (asb : AirSpaceBoundaryModel) => {
          this.pointsService.addAirSpaceBoundaryToMap(asb);
        })
      }
    }

   }
   activateCreateProcedureWindow(): void {
    this.openFooter();
   }


  createAirspaceBoundary(temp_id:number,airspaceBoundary?: AirSpaceBoundaryModel){
    if (!this.projectService.projectEditable()){
      return;
    }
    if(typeof airspaceBoundary == 'undefined'){
      this.selectCoordinatePointService.selectedAirSpaceBoundary = new AirSpaceBoundaryModel();
    }
    else{
      this.selectCoordinatePointService.selectedAirSpaceBoundary = cloneDeep(airspaceBoundary);
    }
    this.currentCreateID = temp_id;
    this.selectCoordinatePointService.originalAirSpaceBoundaryID = "";
    this.activateCreateProcedureWindow();
    this.globalSelectionService.clearAllSelected();
    this.edit = false;

      // this.mapService.draw = new Draw({
      //   source: this.mapService.selectionSource,
      //   type: GeometryType.LINEAR_RING,
      // });
  }

  setInitialStateOfAirSpaceBoundaryFromSelectedVertices(features: Feature[]) : void {
      if (!this.projectService.projectEditable()){
        return;
      }
      this.activateCreateProcedureWindow();
      this.globalSelectionService.clearAllSelected();
      let newProcedure : AirSpaceBoundaryModel = new AirSpaceBoundaryModel();
      newProcedure.airSpaceBoundaryCoordinatePoints = this.createProcedureCoordinatePoints(features);
      newProcedure.airSpaceBoundaryLines = this.createProcedureLegsFromProcedure(newProcedure);
      this.selectCoordinatePointService.selectedAirSpaceBoundary = newProcedure;

  }

  createProcedureCoordinatePoints(features: any) : AirSpaceBoundaryCoordinatePointModel[] {
    let procedureCoordinatePoints : AirSpaceBoundaryCoordinatePointModel[] = [];
    let index : number = 0;

    features.forEach( feat => {
      let newProcedureCoordinatePoint = new AirSpaceBoundaryCoordinatePointModel();
      newProcedureCoordinatePoint.coordPoint = this.pointsService.transformFeatureInCoordinatePoint(feat);
      newProcedureCoordinatePoint.coordPoint.published = true;
      newProcedureCoordinatePoint.sequencenumber = index;
      index++;
      procedureCoordinatePoints.push(newProcedureCoordinatePoint);
    });

    return procedureCoordinatePoints;
  }

  createProcedureLegsFromProcedure( procedure : AirSpaceBoundaryModel) : AirSpaceBoundaryVertexLineModel[]{
    let procedureLegs : AirSpaceBoundaryVertexLineModel[] = [];
    let coordinatePointsSize : number = procedure.airSpaceBoundaryCoordinatePoints.length;
    let legSequenceNumber : number = 0;

    let startPoint: AirSpaceBoundaryCoordinatePointModel;
    let lastPoint: AirSpaceBoundaryCoordinatePointModel;

    startPoint = procedure.airSpaceBoundaryCoordinatePoints[0];
    lastPoint = procedure.airSpaceBoundaryCoordinatePoints[coordinatePointsSize-1];

    for (let i = 0; i < coordinatePointsSize ; i++){
      if (i < coordinatePointsSize -1){
        let newLeg : AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
        newLeg.startPoint = procedure.airSpaceBoundaryCoordinatePoints[i];
        newLeg.endPoint = procedure.airSpaceBoundaryCoordinatePoints[i+1];
        newLeg.sequencenumber = legSequenceNumber++;
        procedureLegs.push(newLeg);
        this.selectCoordinatePointService.addLineToMap(newLeg, procedure);
      }
    }

    let newLeg : AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
    newLeg.startPoint = lastPoint;
    newLeg.endPoint = startPoint;
    newLeg.sequencenumber = legSequenceNumber++;
    procedureLegs.push(newLeg);
    this.selectCoordinatePointService.addLineToMap(newLeg, procedure);

    return procedureLegs;
  }
  getAirSpaceFeatures(){

    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.AirSpaceBoundary);
    if(features.length > 0){
      return features;
    }
    else{
      this.modalService.showMesssageModal("Warning", "Select at least 1 Air Space Boundary to edit.");
    }

  }


  findFeaturebyID(id : string) : Feature {
    let toReturn : Feature = null;
    let layer : VectorLayerDMTR = this.pointsService.airspaceboundariesLayers.childLayers[0].layers
    .find((element) => element.id === 'Air_Space_Boundary')
    .olLayer

    var vectorSource = layer.getSource();
    this.pointsService.getAllAirSpaceBoundaryFeaturesFromLayers().forEach( feature => {
      if(feature.get('id') == id){
        toReturn = feature;
        return;
      }
    });
    return toReturn;
  }
  setEditAirSpaceById(id : string){

    this.pointsService.getAirSpaceBoundaryByID(id).subscribe( (asb : AirSpaceBoundaryModel) => {

      this.selectCoordinatePointService.selectedAirSpaceBoundary = asb;
      let feat : Feature = this.findFeaturebyID(id);
      // if(feat != null){
      //   this.selectCoordinatePointService.selectedAirSpaceBoundary = this.transformFeatureInAirSpaceBoundary(feat);
      // }
      this.selectCoordinatePointService.originalAirSpaceBoundaryID = this.selectCoordinatePointService.selectedAirSpaceBoundary.uniqueid;
      this.restoreMap(false);
      if(!this.foundTemporaryLegs()) {
        this.addProcedureLegsToMap(this.selectCoordinatePointService.selectedAirSpaceBoundary);
      }

      //this.menuService.toogleMenu();
      this.toolsService.navigationOnTop = true;
      this.globalSelectionService.coordinatePointsLayers.childLayers.forEach( child => {
        child.showAll();
      });
     this.setPointer([this.globalSelectionService.coordinatePointsLayers]);

    });

  }
  setEditAirSpace(airspaceBoundary:AirSpaceBoundaryModel ){
    this.selectCoordinatePointService.selectedAirSpaceBoundary = airspaceBoundary;
      let feat : Feature = this.findFeaturebyID(airspaceBoundary.id.toString());
      // if(feat != null){
      //   this.selectCoordinatePointService.selectedAirSpaceBoundary = this.transformFeatureInAirSpaceBoundary(feat);
      // }
      this.selectCoordinatePointService.originalAirSpaceBoundaryID = this.selectCoordinatePointService.selectedAirSpaceBoundary.uniqueid;
      this.restoreMap(false);
      if(!this.foundTemporaryLegs()) {
        this.addProcedureLegsToMap(this.selectCoordinatePointService.selectedAirSpaceBoundary);
      }

      //this.menuService.toogleMenu();
      this.toolsService.navigationOnTop = true;
     this.setPointer([this.globalSelectionService.coordinatePointsLayers]);
     this.edit = true;
  }
  foundTemporaryLegs() : boolean{

    let toReturn : boolean = false;
    let layer : VectorLayerDMTR = this.pointsService.airspaceboundariesLayers.childLayers[0].layers
    .find((element) => element.id === 'Air_Space_Boundary')
    .olLayer

    var vectorSource = layer.getSource();
    this.pointsService.getAllAirSpaceBoundaryFeaturesFromLayers().forEach( feature => {
      if(feature.get('id') == 'TEMP_AIRSPACE_BOUNDARY_' + this.selectCoordinatePointService.selectedAirSpaceBoundary.id){
        toReturn = true;
        return;
      }
    });
    return toReturn;
  }
  editAirspaceBoundary() {
    if (this.projectService.projectEditable()){
      let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.AirSpaceBoundary);
      if(features.length > 1){
        const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
          backdrop: 'static' // Prevent closing on backdrop click
        });
        bsModalRef.content.entity = "Procedures";
        bsModalRef.content.type = "Edit";
        bsModalRef.content.selectAllActive = false;
        bsModalRef.content.data = features;
        bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("Procedures");
      }
      else if(features.length == 1){
        this.selectCoordinatePointService.selectedAirSpaceBoundary = this.transformFeatureInAirSpaceBoundary(features[0]);
        this.deleteAirSpaceBoundary(features, false);
        this.addProcedureLegsToMap(this.selectCoordinatePointService.selectedAirSpaceBoundary);
        this.active = this.active? true : !this.active;
        //this.menuService.toogleMenu();
        this.toolsService.navigationOnTop = true;
        this.globalSelectionService.coordinatePointsLayers.childLayers.forEach( child => {
          child.showAll();
        });
       this.setPointer([this.globalSelectionService.coordinatePointsLayers]);
      }
      else{
        this.modalService.showMesssageModal("Warning", "Select at least 1 Air Space Boundary to edit.");
      }
      this.globalSelectionService.clearAllSelected();
    }
    else {
      console.log('Project not editable');
    }

  }

  bulkUpdateAirspaceBoundaries(airspaceboundaries: AirSpaceBoundaryModel[]): void {
    this.http
      .put(
        this.endpointService.apiUrlAirSpaceBoundaryBulkUpdate,
        airspaceboundaries,
        this.endpointService.httpOptions
      )
      .subscribe(
        (data : ErrorModel[]) => {
          this.pointsService.deleteNavaidsFromMap();
          this.pointsService.fetchAndAddNavaids();
          this.pointsService.deleteCoordinatePointsFromMap();
          this.pointsService.fetchAndAddCoordinatePoints();
          this.pointsService.deleteAirSpaceBoundariesFromMap();
          this.pointsService.fetchAndAddAirSpaceBoundaries();
          this.pointsService.clearSelectedFeatures();
          if(data[0].code == 'OK'){
            this.modalService.showMesssageModal('AirSpace Boudaries', 'AirSpace Boudaries updated successfully.');
          }else {

            let message : string  = '';
            data.forEach( error => {
              if (message.length < 0){
                message = message + error.message + ';';
              }else {
                message = message + ' ' + error.message + ';';
              }
            });
            this.modalService.showMesssageModal("Error", "Error updating AirSpace Boudaries." + message);
          }
        },
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Updating',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal("Error", "Error updating AirSpace Boudaries.");
        }
      );
}

  updateMapStatus(airSpaceBoundary: AirSpaceBoundaryModel): void {
    if (airSpaceBoundary.id != null) {
      this.http
        .patch(
          `${this.endpointService.apiUrlAirSpaceBoundary}/${airSpaceBoundary.id}/mapstatus`,
          airSpaceBoundary,
          this.endpointService.httpOptions
        )
        .subscribe(
          (data : ErrorModel) => {
            if(data.code == 'OK'){
              this.modalService.showMesssageModal('Air Space Boundary', 'Air Space Boundary updated successfully.');
            }else {

              let message = data.message;
              this.modalService.showMesssageModal("Error", "Error creating procedure." + message);
            }
            this.pointsService.deleteAirSpaceBoundariesFromMap();
            this.pointsService.fetchAndAddAirSpaceBoundaries();
            this.pointsService.clearSelectedFeatures();
          },
          (error) => {
            this.modalService.showMesssageModal("Error", "Error updating Air Space Boundary map status procedure.");
          }
        );
    }
    else {
      this.modalService.showMesssageModal('Air Space Boundary', 'Error updating map status: invalid Air Space Boundary ID');
    }
  }

  saveAirSpaceBoundary(airSpaceBoundary: AirSpaceBoundaryModel): void {
    this.restoreMap(true, false);
    if (airSpaceBoundary.id == null) {
      this.uiBlock.startBlock("Creating Airspace Boundary...")
      this.http
        .post(
          this.endpointService.apiUrlAirSpaceBoundary,
          airSpaceBoundary,
          this.endpointService.httpOptions
        )
        .subscribe(
          (data : AirSpaceBoundaryModel) => {
            if(data != null){
              this.modalService.showMesssageModal('Air Space Boundary', 'Air Space Boundary created successfully.');
            }else {
              this.modalService.showMesssageModal("Error", "Error creating airspace boundary.");
            }
            // this.pointsService.deleteNavaidsFromMap();
            // this.pointsService.fetchAndAddNavaids();
            this.pointsService.deleteCoordinatePointsFromMap();
            this.pointsService.fetchAndAddCoordinatePoints();
            this.pointsService.addAirSpaceBoundaryToMap(data);
            this.pointsService.clearSelectedFeatures();
            this.uiBlock.stopBlock();
          },
          (error) => {
            this.uiBlock.stopBlock();
            if (error && error.status == 401) {
              this.modalService.showMesssageModal(
                'Error Saving',
                'Default Project is not editable.'
              )
              return;
            }
            this.modalService.showMesssageModal("Error Updating", "Error creating Air Space Boundary.");
          }
        );
    } else {
      this.uiBlock.startBlock("Updating Airspace Boundary...")
      this.http
        .put(
          this.endpointService.apiUrlAirSpaceBoundary,
          airSpaceBoundary,
          this.endpointService.httpOptions
        )
        .subscribe(
          (data : ErrorModel[]) => {
            this.pointsService.getAirSpaceBoundaryByID(airSpaceBoundary.id.toString()).subscribe( (asb : AirSpaceBoundaryModel) => {
              this.pointsService.addAirSpaceBoundaryToMap(asb);
            })
            this.pointsService.deleteCoordinatePointsFromMap();
            this.pointsService.fetchAndAddCoordinatePoints();
            this.pointsService.clearSelectedFeatures();
            if(data[0].code == 'OK'){
              this.modalService.showMesssageModal('Air Space Boundary', 'Air Space Boundary updated successfully.');
            }else {

              let message : string  = '';
              data.forEach( error => {
                if (message.length < 0){
                  message = message + error.message + ';';
                }else {
                  message = message + ' ' + error.message + ';';
                }
              });
              this.modalService.showMesssageModal("Error", "Error updating procedure." + message);
            }
            this.uiBlock.stopBlock();
          },
          (error) => {
            this.uiBlock.stopBlock();
            if (error && error.status == 401) {
              this.modalService.showMesssageModal(
                'Error Updating',
                'Default Project is not editable.'
              )
              return;
            }
            this.modalService.showMesssageModal("Error", "Error updating Air Space Boundary.");
          }
        );
    }

  }

  deleteAirspaceBoundary() {


    let features : Feature[] = this.pointsService.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.AirSpaceBoundary);
    if(features.length == 0){
      this.modalService.showMesssageModal("Warning", "Select at least 1 Air Space Boundary to delete.");
      return;
    }

    const bsModalRef : BsModalRef = this.popupService.show(DynamicTable, {
      backdrop: 'static' // Prevent closing on backdrop click
    });
    bsModalRef.content.entity = "Air Space Boundary";
    bsModalRef.content.type = "Delete";
    bsModalRef.content.selectAllActive = true;
    bsModalRef.content.data = features;
    bsModalRef.content.displayedColumns = this.utilsService.getDynamicTableColumns("AirSpaceBoundaries");
    bsModalRef.content.onClose.subscribe(result => {
      if(result.length>0){
        let list : Feature[] = [];
        result.forEach(element => {
          list.push(this.pointsService.getSelectedFeatures().find(x => x.get("id") == element.get("id") && x.get("featureType") == FeatureType.AirSpaceBoundary ));
        });
        this.modalConfirmation.showMesssageConfirmationModal("Delete Air Space Boundary", "Do you want to delete the selected Air Space Boundary?", "Yes", "No", () => this.deleteAirSpaceBoundary(list, true));
      }
    });
  }

  transformFeatureInAirSpaceBoundary(
    arg0: Feature<import('ol/geom/Geometry').default>
  ): AirSpaceBoundaryModel {
    let model: AirSpaceBoundaryModel = new AirSpaceBoundaryModel();
    model.id = arg0.get('id');
    model.airspaceboundaryid = arg0.get('airspaceboundaryid');
    model.uniqueid = arg0.get('uniqueid');
    model.airSpaceBoundaryCoordinatePoints = arg0.get('airSpaceBoundaryCoordinatePoints');
    model.airSpaceBoundaryLines  = arg0.get('airSpaceBoundaryLines');
    model.name  = arg0.get('name');

    model.airSpaceBoundaryCoordinatePoints.forEach(coordPoint => {
      coordPoint.coordPoint.userdefined = true;
      coordPoint.coordPoint.published = true;

    });

    // This actions are needed to apply the date conversion for each date field in each navaid
    let resultingNavaids : NavaidModel[] = [];
    let navaids : NavaidModel[] = arg0.get('navaids');
    navaids.forEach( nav => {
      let navaidPayload = this.navaidController.getNavaidPayload(nav);
      navaidPayload.critical = nav.critical;
      resultingNavaids.push(navaidPayload);
    });

    model.navaids = resultingNavaids;

    return model;
  }

  public deleteAirSpaceBoundary(features : Feature[], fromMapAndDatabase : boolean): void {

    let source;
    source = this.pointsService.airspaceboundariesLayers.childLayers[0].layers
    .find((element) => element.id === 'Air_Space_Boundary')
    .olLayer.getSource();
    if(fromMapAndDatabase){
      this.uiBlock.startBlock("Deleting Airspace Boundaries...");
      let airspaces : AirSpaceBoundaryModel[] = [];
      features.forEach((feature) => {
        let air : AirSpaceBoundaryModel = this.pointsService.transformFeatureInAirspaceBoundary(feature);
        airspaces.push(air);
      });
      this.pointsService.deleteAirspaceBoundaryBulk(airspaces).subscribe(
        (result) => {
          features.forEach((feature) => {
            source.removeFeature(feature);
            this.pointsService.removeSelectedFeature(feature);
             // update navaid's associated airspace boundaries list
            if (feature.get("navaids") != null && feature.get("navaids").length > 0){
              for (const navaid of feature.get("navaids") as NavaidModel[]){
                const navaidFeature: Feature<Geometry> = this.pointsService.getNavaidFeatureFromLayers(navaid.id.toString());
                const associatedAirspaceBoundaries: AirSpaceBoundaryModel[] = navaidFeature.get("associatedAirspaceBoundaries");
                const index = associatedAirspaceBoundaries.findIndex(p => p.id == feature.get("id"));
                if (index != -1){
                  associatedAirspaceBoundaries.splice(index, 1);
                  navaidFeature.set("associatedAirspaceBoundaries", associatedAirspaceBoundaries);
                }
              }
            }
          });
          for (const airspace of airspaces){
            const airspaceConfigIndex: number = this.configurationService.currentConfiguration.airspaceBoundaries.findIndex(p => p.id == airspace.id);
            if (airspaceConfigIndex != -1){
              this.configurationService.currentConfiguration.airspaceBoundaries.splice(airspaceConfigIndex, 1);
            }
          }
          this.modalService.showMesssageModal("AirSpace Boundaries", "AirSpace Boundaries deleted with success.");
          this.uiBlock.stopBlock();
        },
        (error) => {
          this.uiBlock.stopBlock();
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Deleting',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal("AirSpace Boundaries", "Error deleting Airspace Boundaries.");
        });

    }else {
      features.forEach((feature) => {
        source.removeFeature(feature);
        this.pointsService.removeSelectedFeature(feature);
      });
    }
  }

  deleteProcedureFromDb(id: string): Observable<boolean> {
    this.http
      .delete<boolean>(
        this.endpointService.apiUrlAirSpaceBoundary + '/' + id,
        this.endpointService.httpOptions
      )
      .subscribe(
        () => {
          const asbConfigIndex: number = this.configurationService.currentConfiguration.airspaceBoundaries.findIndex(p => p.id.toString() == id);
          if (asbConfigIndex != -1){
            this.configurationService.currentConfiguration.airspaceBoundaries.splice(asbConfigIndex, 1);
          }
          return true;
        },
        (error) => {
          if (error && error.status == 401) {
            this.modalService.showMesssageModal(
              'Error Deleting',
              'Default Project is not editable.'
            )
            return;
          }
          this.modalService.showMesssageModal("Error Deleting", "Error deleting Air Space Boundary.");
        }
      );
    return of(false);
  }

  private addProcedureLegsToMap(airspaceBoundary : AirSpaceBoundaryModel) {
    let source = this.pointsService.airspaceboundariesLayers.childLayers[0].layers
    .find((element) => element.id === 'Air_Space_Boundary')
    .olLayer.getSource();

    let marker : Feature[] = this.createAirSpaceBoundaryLineFeatures(airspaceBoundary);

    marker.forEach( feat => {
      source.addFeature(feat);
    });


  }

  private createAirSpaceBoundaryLineFeatures(obj: AirSpaceBoundaryModel): Feature [] {
    let features : Feature[] = [];



    for(let index = 0; index < obj.airSpaceBoundaryCoordinatePoints.length; index++) {
      let points = [];
      obj.airSpaceBoundaryLines = [];

      let startPoint : AirSpaceBoundaryCoordinatePointModel = obj.airSpaceBoundaryCoordinatePoints[0];

      points.push([
        startPoint.coordPoint.longitude,
        startPoint.coordPoint.latitude,
      ]);

      for (let index = 1; index < obj.airSpaceBoundaryCoordinatePoints.length; index++) {
        let previousPoint  : AirSpaceBoundaryCoordinatePointModel = obj.airSpaceBoundaryCoordinatePoints[index - 1];
        let currentPoint  : AirSpaceBoundaryCoordinatePointModel = obj.airSpaceBoundaryCoordinatePoints[index];

        if (index == 1) {
          let line: AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
          line.isstraightleg = true;
          line.startPoint = startPoint;
          line.endPoint = currentPoint;

          obj.airSpaceBoundaryLines.push(line);
        }
        else {
          let line: AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
          line.isstraightleg = true;
          line.startPoint = previousPoint;
          line.endPoint = currentPoint;
          obj.airSpaceBoundaryLines.push(line);
        }

        points.push([
          currentPoint.coordPoint.longitude,
          currentPoint.coordPoint.latitude,
        ]);

        if (index === obj.airSpaceBoundaryCoordinatePoints.length - 1) {
          points.push([
            startPoint.coordPoint.longitude,
            startPoint.coordPoint.latitude,
          ]);

          let lastLine: AirSpaceBoundaryVertexLineModel = new AirSpaceBoundaryVertexLineModel();
          lastLine.isstraightleg = true;
          lastLine.startPoint = currentPoint;
          lastLine.endPoint = startPoint;

          obj.airSpaceBoundaryLines.push(lastLine);
        }
      }

      for (var i = 0; i < points.length; i++) {
        points[i] = olProj.transform(points[i], 'EPSG:4326', this.mapService.getMaps().getView().getProjection());
      }

      let feat = new Feature({
        geometry: new LineString(points),
        airspaceboundaryid:  obj.airspaceboundaryid,
        uniqueid: obj.uniqueid,
        id: obj.id,
        airSpaceBoundaryCoordinatePoints: obj.airSpaceBoundaryCoordinatePoints,
        airSpaceBoundaryLines: obj.airSpaceBoundaryLines,
        name: obj.name,
        navaids: obj.navaids,
        selectedOnManage: false,
        featureType : FeatureType.AirSpaceBoundary
      });


      features.push(feat);
    }

    return features;
  }

  setPointer(layers:ParentLayers[]){

    this.globalSelectionService.clearAllSelected();
    layers.forEach((element)=>element.layersSelector.pointer=true)

    this.mapService.select = new Select({
      style:null,
      //train wreck anti pattern....
      layers:layers.map(layers => layers.childLayers.map(child => child.layers).reduce((acc,val)=>acc.concat(val))
                  .map(layer => layer.olLayer)).reduce((accumulator, value) => accumulator.concat(value)),
      hitTolerance: 5
    })


    var thisObject = this.globalSelectionService;
    var thisService = this;
    // TODO: Remove listener dblclick when not necessary anymore
    /*
    this.mapService.getMap('map').on('dblclick', function(event){


      let source = this.pointsService.airspaceboundariesLayers.childLayers[0].layers
    .find((element) => element.id === 'Air_Space_Boundary')
    .olLayer.getSource();


      let sourceWaypoint = this.coordinatePointsLayers.childLayers[0].layers
        .find((element) => element.id === 'waypoint')
        .olLayer.getSource();

      var closestAirspaceFeatures = sourceWaypoint.getClosestFeatureToCoordinate(event);
      console.log();
    });*/

    //this.mapService.getMap('map').addInteraction(this.mapService.select);
  }

  createAirSpaceBoundaryFromFile(event) : void {
    let target = event.target || event.srcElement;
    if (this.projectService.projectEditable()){
      this.uploadCPXMLAndOpenProcedureCreation(target.files[0]);
    }
    target.value = '';
  }

  public uploadCPXMLAndOpenProcedureCreation(fileToUpload: File) {
    // const formData: FormData = new FormData();
    // formData.append('file', fileToUpload, fileToUpload.name);
    // var promise = new Promise((resolve, reject) => {
    //   this.uiBlock.startBlock(
    //     'Loading Coordinate Points data from XML file...'
    //   );
    //   this.http
    //     .post(
    //       this.endpointService.endpointUploadCoordinatePoints,
    //       formData,
    //       this.endpointService.httpOptions
    //     )
    //     .subscribe(
    //       (data) => {
    //         let newProcedure : ProcedureModel = new ProcedureModel();
    //         newProcedure.procedureCoordinatePoints = this.createProcedureCoordinatePointsFromCoordinatePoints(data);
    //         newProcedure.procedureLegs = this.createProcedureLegsFromProcedure(newProcedure);
    //         this.selectProcedureService.selectedProcedure = newProcedure;
    //         this.activateCreateProcedureWindow();
    //         this.globalSelectionService.clearAllSelected();
    //         this.pointsService.deleteCoordinatePointsFromMap();
    //         this.pointsService.getCoordiantePoints().subscribe((cps) =>
    //           cps.forEach((element) => {
    //             this.pointsService.addCoordinatePointToMap(element);
    //           })
    //         );
    //         this.uiBlock.stopBlock();
    //       },
    //       (error) => {
    //         this.uiBlock.stopBlock();
    //         return new Array<string>();
    //       }
    //     );
    // });
  }

}
